import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  Grid,
  GridItem,
  Image,
  Divider,
  Flex,
  Link,
  Button,
  ButtonGroup,
} from "@chakra-ui/react";
import CuLogo from "../assets/cu-logo-head.png";
import Card from "../../../Components/TraceApp/VerificationCard/Card";
import { CottonIcon, ForwardIcon, Loader } from "../assets/Icons";
import { useNavigate, useParams } from "react-router-dom";
import FarmersDetails from "./FarmersDetails";
import axios from "axios";
import { useCallback } from "react";
import { getClientTrace, getTcDetailFoTrace } from "./api";
import Textprocil from "../../../assets/Texprocil.png";

const HomePageV4 = ({ id, traceVersion }) => {
  const [traceDetails, setTraceDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [companiesList, setCompaniesList] = useState([]);
  const [supplierList, setSupplierList] = useState({});
  const [categories, setCategories] = useState({});
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  const getTraceDetails = async (id, traceVersion) => {
    setIsLoading(true);
    try {
      const res = await getClientTrace(id, (traceVersion = 4));
      console.log(res?.data);
      if (res?.status === "success") {
        setTraceDetails(res?.data);
      }
    } catch (error) {
      console.log(error.message);
    }
    setIsLoading(false);
  };

  // useEffect(() => {
  //   getTraceDetails(id, (traceVersion = 4));
  //   localStorage.setItem(id, "id");
  // }, [id]);

  useEffect(() => {
    if (id && traceVersion !== undefined) {
      getTraceDetails(id);
      localStorage.setItem(id, "id");
    }
  }, [id, traceVersion]);

  useEffect(() => {
    setIsLoading(true);
    if (traceDetails) {
      const { Farmer, APMC, BROKER, EXTERNAL_CLIENT, ...otherData } =
        traceDetails;

      setCompaniesList(
        Object.entries(otherData).map(([key, value]) => ({ key, data: value }))
      );
    }
    setIsLoading(false);
  }, [traceDetails]);

  const navigate = useNavigate();
  const handleGoDetail = (company, traceVersion) => {
    navigate(
      `./${
        company?.data?.tc_seller?.name
          ? company?.data?.tc_seller?.name
          : company?.name
      }`,
      {
        state: { company: company, traceVersion: 4 },
      }
    );
  };

  useEffect(() => {
    setIsLoading(true);
    if (traceDetails) {
      const extractedData = {
        Farmer: traceDetails?.Farmer || [],
        APMC: traceDetails?.APMC || [],
        BROKER: traceDetails?.BROKER || [],
        EXTERNAL_CLIENT: traceDetails?.EXTERNAL_CLIENT || [],
      };
      console.log(extractedData);

      setSupplierList(extractedData);
    }

    if (supplierList) {
      const defaultCategory = Object.keys(supplierList).find(
        (category) =>
          supplierList[category] && supplierList[category].length > 0
      );
      if (defaultCategory) {
        setSelectedCategory(defaultCategory);
      }
    }

    setIsLoading(false);
  }, [traceDetails]);

  if (!id || traceVersion === undefined) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        width="100%"
      >
        <Loader width="80px" height="80px" color="#3958DC" />
      </Box>
    );
  }

  return (
    <>
      {isLoading ? (
        <Box marginTop={"2rem"} textAlign={"center"}>
          <Loader width="50px" height="50px" color="#3958DC" />
          <Text fontSize="16px" fontWeight={"700"} marginTop={"10px"}>
            Loading the Trace...
          </Text>
        </Box>
      ) : (
        <Box bg="white" maxW="480px">
          <Box
            bg="#EFEFF4"
            width={"100%"}
            borderBottomRadius={"15px"}
            boxShadow={"rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}
          >
            <Grid templateColumns="repeat(2, 1fr)" pb="1rem" px="2rem">
              <GridItem>
                {/* <Text fontSize={"15px"} fontWeight={"800"}>
                  Howdy,
                </Text>
                <Text fontSize={"15px"} fontWeight={"400"}>
                  It’s a nice day
                </Text> */}
                <Image
                  src={Textprocil}
                  h="70px"
                  w="160px"
                  alt="Control Union"
                />
              </GridItem>
              <GridItem justifySelf={"end"} pt="0.65rem">
                <Link
                  href="https://certifications.controlunion.com/en"
                  target="_blank"
                >
                  <Image boxSize="55px" src={CuLogo} alt="Control Union" />
                </Link>
              </GridItem>
            </Grid>
          </Box>

          <Card id={id} traceVersion={traceVersion} />

          <Box mx={"2rem"}>
            <Box display={"flex"} alignItems={"center"} my={"2rem"}>
              <CottonIcon mt="10px" /> &nbsp;
              <Text fontSize="14px" fontWeight={"400"} mt={"0.5rem"}>
                100% Cotton From Certified Farmers
              </Text>
            </Box>
            <ButtonGroup
              size="md"
              isAttached
              variant="outline"
              mt="1rem"
              borderRadius="15px"
              display="flex"
              justifyContent="center"
              alignItems="center"
              spacing={"6"}
            >
              {["Farmer", "BROKER", "APMC", "EXTERNAL_CLIENT"]
                .filter(
                  (category) =>
                    supplierList[category] && supplierList[category].length > 0
                )
                .map((category) => (
                  <Button
                    key={category}
                    onClick={() => setSelectedCategory(category)}
                    colorScheme={
                      selectedCategory === category ? "white" : "gray"
                    }
                    color={"black"}
                    variant={
                      selectedCategory === category ? "solid" : "outline"
                    }
                    bg={selectedCategory === category ? "white" : "gray.200"}
                    boxShadow={
                      selectedCategory === category
                        ? "0 2px 4px rgba(0, 0, 0, 0.2)"
                        : "none"
                    }
                    borderRadius={"15px"}
                  >
                    {category}
                  </Button>
                ))}
            </ButtonGroup>

            {supplierList[selectedCategory] && (
              <Box mt="1rem" mb="2rem" mx="0.5rem">
                <Grid templateColumns="2fr 0.2fr">
                  <GridItem>
                    <Grid templateColumns="1fr 1fr 1fr">
                      <GridItem my="20px">
                        <Flex
                          flexDirection="column"
                          justifyContent="space-between"
                          height="100%"
                        >
                          {/* <Box>
                                                        <Text fontSize="12px" fontWeight="500">
                                                            Input Product
                                                        </Text>
                                                        {Object.keys(categories[selectedCategory]).map((state) =>
                                                            categories[selectedCategory][state].inputProduct.map((input) => (
                                                                <Text color="#AFAFAF" fontSize="12px" key={input}>
                                                                    {input}
                                                                </Text>
                                                            ))
                                                        )}
                                                    </Box> */}

                          <Text w="84px" color="#D9D9D9">
                            ----------
                          </Text>

                          <Box>
                            <Text fontSize="12px" fontWeight="500">
                              Output Product
                            </Text>
                            {/* {Object.keys(categories[selectedCategory]).map((state) =>
                                                            categories[selectedCategory][state].outputProduct.map((output) => (
                                                                <Text color="#AFAFAF" fontSize="12px" key={output}>
                                                                    {output}
                                                                </Text>
                                                            ))
                                                        )} */}
                            Seeded Cotton
                          </Box>
                        </Flex>
                      </GridItem>
                      <GridItem>
                        <Box
                          w="14px"
                          bg={
                            selectedCategory === "Farmers"
                              ? "#9CE8B3"
                              : selectedCategory === "APMC"
                              ? "#477AD4"
                              : "#EC806A"
                          }
                          height="100%"
                          mx="2rem"
                          borderRadius="10px"
                        />
                      </GridItem>
                      <GridItem>
                        <Box my="1rem">
                          <Text fontSize="15px" fontWeight="700">
                            {traceDetails[selectedCategory]?.map((cat) => (
                              <Text>
                                {cat?.name
                                  ? cat?.name
                                  : `${cat?.firstName}${" "}${cat?.lastName}`}
                              </Text>
                            )) || selectedCategory}
                          </Text>
                          {/* {Object.keys(categories[selectedCategory]).map((state, index, array) => (
                                                        <Text fontSize="12px" fontWeight="400" as="span" key={state}>
                                                            {state}
                                                            {index < array.length - 1 ? ", " : ""}
                                                        </Text>
                                                    ))} */}
                          <Box fontSize="12px" color="#AFAFAF">
                            {/* {Object.keys(categories[selectedCategory]).map((state) =>
                                                                categories[selectedCategory][state].sellerNames.map((sellerName) => (
                                                                    <span key={sellerName}>{sellerName}</span>
                                                                ))
                                                            )} */}
                          </Box>
                        </Box>
                        <GridItem display={"flex"} justifyContent={"end"}>
                          <ForwardIcon
                            mt="1rem"
                            onClick={() => {
                              if (selectedCategory === "Farmer") {
                                navigate("./Farmer", {
                                  state: { traceVersion: 4 },
                                });
                              } else {
                                handleGoDetail(
                                  traceDetails[selectedCategory][0]
                                );
                              }
                            }}
                          />
                        </GridItem>
                      </GridItem>
                    </Grid>
                  </GridItem>
                </Grid>
              </Box>
            )}

            {companiesList?.map((company, idx) => {
              return (
                <Box mt="1rem" mb="2rem" mx="0.5rem" key={company?.id}>
                  <Grid templateColumns="2fr 0.2fr">
                    <GridItem>
                      <Grid templateColumns="1fr 1fr 1fr">
                        <GridItem my="20px">
                          <Flex
                            flexDirection="column"
                            justifyContent="space-between"
                            height="100%"
                          >
                            <Box>
                              <Text fontSize="12px" fontWeight="500">
                                Input Product
                              </Text>
                              {company?.data?.products
                                ?.flatMap((product) => product?.inputs || [])
                                ?.map(
                                  (input) => input?.productClassification?.name
                                )
                                ?.filter(Boolean)
                                ?.reduce(
                                  (unique, name) => unique.add(name),
                                  new Set()
                                )?.size > 0
                                ? [
                                    ...new Set(
                                      company?.data?.products
                                        ?.flatMap(
                                          (product) => product?.inputs || []
                                        )
                                        ?.map(
                                          (input) =>
                                            input?.productClassification?.name
                                        )
                                        ?.filter(Boolean)
                                    ),
                                  ].join(", ")
                                : "N/A"}
                            </Box>

                            <Text w="84px" color="#D9D9D9">
                              ----------
                            </Text>

                            <Box>
                              <Text fontSize="12px" fontWeight="500">
                                Output Product
                              </Text>
                              {company?.data?.products?.length > 0 &&
                              company?.data?.products[
                                company?.data?.products?.length - 1
                              ]?.productId?.product_productClassification?.name
                                ? company?.data?.products[
                                    company?.data?.products?.length - 1
                                  ]?.productId?.product_productClassification
                                    ?.name
                                : "N/A"}
                            </Box>
                          </Flex>
                        </GridItem>
                        <GridItem>
                          <Box
                            w="14px"
                            bg={
                              selectedCategory === "Farmer"
                                ? "#9CE8B3"
                                : selectedCategory === "BROKER"
                                ? "#477AD4"
                                : "#EC806A"
                            }
                            height="100%"
                            mx="2rem"
                            borderRadius="10px"
                          />
                        </GridItem>
                        <GridItem>
                          <Box my="1rem">
                            <Text fontSize="15px" fontWeight="700">
                              {company?.data?.tc_seller?.name
                                ? company?.data?.tc_seller?.name
                                : company?.data[0]?.name}
                            </Text>
                            <Box fontSize="12px" color="#AFAFAF">
                              {company?.data?.products?.map((product) =>
                                product?.process?.map((prc) => (
                                  <Text
                                    fontSize="12px"
                                    fontWeight="400"
                                    key={prc?._id}
                                  >
                                    {prc?.name}
                                  </Text>
                                ))
                              )}
                            </Box>
                          </Box>
                          <GridItem display={"flex"} justifyContent={"end"}>
                            <ForwardIcon
                              onClick={() => handleGoDetail(company)}
                            />
                          </GridItem>
                        </GridItem>
                      </Grid>
                    </GridItem>
                  </Grid>
                </Box>
              );
            })}
          </Box>
        </Box>
      )}
    </>
  );
};

export default HomePageV4;
